const paddingClasses = {
  sm: "p-6",
  md: "p-7 md:p-8",
  lg: "p-7 md:p-9",
};

/**
 * Rounded white card with optional hover lift.
 *
 * @param {Object} props
 * @param {import("react").ReactNode} props.children - card content
 * @param {"sm" | "md" | "lg"} [props.padding] - inner padding, defaults to md
 * @param {boolean} [props.hover] - enable hover lift + shadow
 * @param {string} [props.className] - extra classes
 * @returns {import("react").ReactElement}
 */
export function Card(props) {
  const { children, padding = "md", hover = false, className = "" } = props;

  const base = "bg-white rounded-[20px] shadow-card border border-line/60";
  const hoverClass = hover
    ? "transition-all duration-300 hover:-translate-y-1 hover:shadow-card-hover"
    : "";

  return (
    <div className={`${base} ${paddingClasses[padding]} ${hoverClass} ${className}`.trim()}>
      {children}
    </div>
  );
}
